<template>
  <div class="event-modal-passes-add-form__row flex">
    <div class="event-modal-passes-add-form__row-col _270">
      <Dropdown
        :key="value ? value.id : 'empty'"
        :value="options"
        :title="$t('services.ordering.standSelectTitle')"
        :preheader="$t('services.ordering.standSelectPreheader')"
        label-name="title"
        single
        modified
        required
        without-opacity-title
        @select="$emit('input', $event)"
      />
      <span v-if="error" class="event-modal-stand-fields__error">
        {{ error }}
      </span>
    </div>

    <div class="event-modal-passes-add-form__row-col _270">
      <InputLabel class="form__input">
        <template #label>{{ $t("services.ordering.pavilion") }}</template>
        <input :value="pavilion" disabled />
      </InputLabel>
    </div>

    <div class="event-modal-passes-add-form__row-col _200">
      <InputLabel class="form__input">
        <template #label>{{ $t("services.ordering.hall") }}</template>
        <input :value="hall" disabled />
      </InputLabel>
    </div>
  </div>
</template>

<script>
import { Dropdown, InputLabel } from "@v2/shared/ui/components";

export default {
  name: "EventModalStandFields",
  components: { Dropdown, InputLabel },
  props: {
    stands: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      default: null
    },
    error: {
      type: String,
      default: ""
    }
  },
  computed: {
    options() {
      return this.stands.map(stand => ({
        ...stand,
        selected: stand.id === this.value?.id
      }));
    },
    pavilion() {
      return this.value?.pavilion?.parent
        ? this.$options.filters.localeField(this.value.pavilion.parent, "title")
        : "";
    },
    hall() {
      return this.value?.pavilion
        ? this.$options.filters.localeField(this.value.pavilion, "title")
        : "";
    }
  }
};
</script>

<style lang="scss" scoped>
.event-modal-stand-fields__error {
  display: block;
  margin-top: 8px;
  color: #d8000c;
  font-size: 12px;
}
</style>
